import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Constants } from 'src/app/app.constants';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {

  constructor(private router: Router,private activatedRoute:ActivatedRoute) { }

  accessToken:any;

  ngOnInit(): void {
    // debugger
    this.accessToken = this.activatedRoute.snapshot.fragment;
  }

  backToLoginPage(){
      // this.router.navigate(['login']);
      window.location.href=Constants.LOGIN_URL;
  }

}
